import angular from "angular";
import uiRouter from "angular-ui-router";
import trainingCentersListComponent from "./trainingCentersList.component";

let trainingCentersModule = angular
  .module("trainingCentersList", [uiRouter])
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("trainingCenters", {
      url: "/trainingCenters",
      component: "trainingCentersList",
      data: { pageTitle: "trainingCenters" },
      resolve: {
        hasPermission: ($q, $rootScope, Permissions) => {
          "ngInject";
          let deferred = $q.defer();
          if ($rootScope.user.canDo(Permissions.VIEW_ALL_TRAINING_ENTRIES)) {
            deferred.resolve();
          } else {
            deferred.reject("Access Denied!!");
          }
          return deferred.promise;
        },
      },
    });
  })
  .component("trainingCentersList", trainingCentersListComponent).name;

export default trainingCentersModule;



// WEBPACK FOOTER //
// ./client/app/components/trainingCenters/trainingCentersList/trainingCentersList.js